<template>
<div class="container-fluid">
    <div class="card footer">
        <div class="d-flex flex-row justify-content-around">
            <div class="p-1 mt-1 mt-md-0 mb-1 mb-md-0 ml-2 d-flex" id="people" @click="NavToHome" :class="{'active':  currentRoute === 'MainHome'}">
                <img :src="homeSvg" class="img-fluid footericons my-auto" alt="home" title="Home"/>
                <label class="bold ml-2 mt-2 p-1 d-none d-md-block">Home</label>
            </div>
            <div class="p-1 mt-1 mt-md-0 mb-1 mb-md-0 mr-2 d-flex" id="people" @click="NavToPeople" :class="{'active':  currentRoute === 'People'}">
                <img :src="peopleSvg" class="img-fluid footericons my-auto" alt="people" title="People" />
                <label class="bold ml-2 mt-2 p-1 d-none d-md-block">People</label>
                <!-- <router-link to="/people" tag="a">
                    <img src="../assets/People.svg" class="img-fluid mr-2" />
                    <label class="bold ml-2 mt-2 p-1 d-none d-md-block sidemenuItem">People</label>
                </router-link> -->
            </div>
            <div class="p-1 mt-1 mt-md-0 mb-1 mb-md-0 mr-2 d-flex" @click="openPostVideoModal">
                <img src="../assets/postvidfooter.svg" class="img-fluid footericons1 my-auto" alt="postvideo" title="Post A Video"/>
                <label class="bold ml-2 mt-2 p-1 d-none d-md-block flex-nowrap">Post Video</label>
            </div>
            <div class="p-1 mt-1 mt-md-0 mb-1 mb-md-0 mr-2 d-flex" @click="NavToJob" id="people" :class="{'active': currentRoute === 'job'}">
                <img :src="jobSvg" class="img-fluid footericons my-auto" alt="job" title="Job"/>
                <label class="bold ml-2 mt-2 p-1 d-none d-md-block">Job</label>
            </div>
        </div>
        <postvideomodal v-if="postavideomodalopen" class="footermodal" @close = "closeModal"></postvideomodal>
        <no-profile-id-modal-component v-if="displayNoProfileModalComponent" @closeNoProfileIdModal="closeNoProfileIdModal"></no-profile-id-modal-component>
    </div>
</div>
</template>
<script>
import router from '../router.js'
import postvideomodal from '../components/postVideoModal.vue'
import NoProfileIdModalComponent from '../components/NoprofileIdModal.vue'
import { bus } from "../main";
import httpuserprofile from '../js/http-userprofile.js'
import sessionUtils from '@/js/session-util.js'
export default {
    data(){
        return{
            // peopleSvg: require('../assets/People.svg'),
            postavideomodalopen : false,
            currentRoute: '',
            selectElement: '',
            peopleSvg: null,
            homeSvg: null,
            jobSvg: null,
            profileId : null,
            displayNoProfileModalComponent : false
        }
    },
    components: {
        postvideomodal,
        NoProfileIdModalComponent
    },
    methods : {
        closeModal() {
            this.postavideomodalopen = false;
        },
        NavToPeople : function() {
            this.closetoggleMenu()
            sessionUtils.setSelectedElement('people')
                router.push({
                    name : 'People'
                })
                bus.$emit('refreshDatawhenInSamePeoplePage', true)
        },
        NavToJob: function(){
            this.closetoggleMenu()
            sessionUtils.setSelectedElement('job')
             router.push({
                    name : 'job'
                })
                bus.$emit('refreshDatawhenInSameJobPage', true)
        },
        NavToHome : function() {
            this.closetoggleMenu()
                sessionUtils.setSelectedElement('home')
                router.push({
                    name : 'MainHome'
                })
        },
        closetoggleMenu(){
            bus.$emit('closetogglesidemenu', true)
        },
        openPostVideoModal() {
            this.closetoggleMenu()
            if(this.profileId) {
                this.postavideomodalopen = true;
                this.displayNoProfileModalComponent = false;
            }else{
                this.displayNoProfileModalComponent = true;
                this.postavideomodalopen = false;
            }
        },
        closeNoProfileIdModal(){
            this.displayNoProfileModalComponent = false;
        },
        getUserByID(){     
            httpuserprofile.get('/userprofile/userbyid/'+sessionUtils.getUserId())
            .then(response =>{
                this.profileId = response.data.profileId;
                }
            )
        },
    },
    mounted(){
    var that = this;
    this.getUserByID()
    setInterval(function(){ 
        that.currentRoute = that.$router.currentRoute.name;
        that.selectElement = sessionUtils.getSelectedElement();
        
        if( that.currentRoute === 'MainHome'){      
        that.homeSvg = require('../assets/Homeblue.svg');
        that.peopleSvg =require('../assets/People.svg');
        that.jobSvg = require('../assets/Job.svg');
      
    }else if( that.currentRoute === 'People'){
        that.homeSvg = require('../assets/Home.svg');
        that.peopleSvg =require('../assets/Peopleblue.svg');
        that.jobSvg = require('../assets/Job.svg');
    }else if( that.currentRoute === 'job'){    
        that.homeSvg = require('../assets/Home.svg');
        that.peopleSvg =require('../assets/People.svg');
        that.jobSvg = require('../assets/Jobblue.svg');
    }else if(that.currentRoute === 'track'  ){
       that.homeSvg = require('../assets/Home.svg');
       that.peopleSvg =require('../assets/People.svg');
       that.jobSvg = require('../assets/Job.svg');
    }
    }, 1000)
   if(this.currentRoute !== 'MainHome' && this.currentRoute !== 'People' && this.currentRoute !== 'job'  ){
       this.homeSvg = require('../assets/Home.svg');
       this.peopleSvg =require('../assets/People.svg');
       this.jobSvg = require('../assets/Job.svg');
    }
    if(this.selectElement === undefined){        
       this.peopleSvg =require('../assets/People.svg');
       this.homeSvg = require('../assets/Home.svg');
       this.jobSvg = require('../assets/Job.svg');
    }
    }
}
</script>
<style scoped>
.footermodal{
    z-index: 1000 !important;
}
a{
    color: black;
}
.footericons{
    width: 22px !important;
    height: 22px !important;
}
.footericons1{
    width: 25px !important;
    height: 20px !important;
}
#people:hover{
   background-color: rgba(161, 166, 179,0.06);
   color: #007AFF !important;
   cursor: pointer;
}
.active{
  /* border: 2px solid #007AFF;  
  background-color: #d6e9ff  !important; */
  background-color: rgba(161, 166, 179,0.06);
   color: #007AFF !important;
   cursor: pointer;
}
#people:active{
  border: 2px solid #007AFF;  
  background-color: #d6e9ff;
}

</style>